import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AppContext';
import { Shield, Eye, EyeOff, LogIn } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm]       = useState({ email: '', password: '', userType: 'superadmin' });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password, form.userType);
      toast.success('Welcome back, ' + user.name + '!');
      if (user.userType === 'superadmin') navigate('/superadmin/dashboard');
      else if (user.userType === 'admin')  navigate('/admin/dashboard');
      else navigate('/subadmin/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Login failed');
    } finally { setLoading(false); }
  };

  const fillDemo = (type, email, pw) => setForm({ email, password: pw, userType: type });

  return (
    <div className="auth-page">
      <div className="auth-bg-grid" />
      <div className="auth-bg-glow" />
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon"><Shield size={22} color="white" /></div>
          <div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:'1.3rem', fontWeight:800 }}>AdminHub</div>
            <div style={{ fontSize:'.72rem', color:'var(--text-muted)', letterSpacing:'.05em', textTransform:'uppercase' }}>Access Control System</div>
          </div>
        </div>

        <h1 className="auth-title">Sign in</h1>
        <p className="auth-subtitle">Enter your credentials to continue</p>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:6, background:'var(--bg-base)', borderRadius:'var(--r-md)', padding:4, marginBottom:22, border:'1px solid var(--border)' }}>
          {[['superadmin','Super Admin'],['admin','Admin'],['subadmin','Employee']].map(([v,l]) => (
            <button key={v} type="button" onClick={() => setForm(f=>({...f, userType:v}))}
              style={{ padding:'7px 4px', borderRadius:'var(--r-sm)', border:'none', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:'.78rem', fontWeight:600, transition:'all 150ms', background: form.userType===v ? 'var(--bg-card)' : 'transparent', color: form.userType===v ? 'var(--brand)' : 'var(--text-muted)', boxShadow: form.userType===v ? 'var(--shadow-sm)' : 'none' }}>
              {l}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} required />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position:'relative' }}>
              <input className="form-input" type={showPwd?'text':'password'} placeholder="••••••••" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} required style={{ paddingRight:42 }} />
              <button type="button" onClick={()=>setShowPwd(s=>!s)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text-muted)' }}>
                {showPwd ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          </div>
          <button className="btn btn-primary w-full" type="submit" disabled={loading} style={{ marginTop:6, justifyContent:'center', padding:'11px' }}>
            {loading ? <span className="spinner"/> : <><LogIn size={16}/> Sign In</>}
          </button>
        </form>

        <div style={{ marginTop:24, padding:14, background:'var(--bg-base)', borderRadius:'var(--r-md)', border:'1px solid var(--border)' }}>
          <p style={{ fontSize:'.7rem', fontWeight:700, color:'var(--text-muted)', letterSpacing:'.07em', textTransform:'uppercase', marginBottom:8 }}>Demo Credentials</p>
          <button type="button" onClick={()=>fillDemo('superadmin','superadmin@example.com','superadmin123')} style={{ display:'block', width:'100%', textAlign:'left', background:'none', border:'none', cursor:'pointer', padding:'3px 0', color:'var(--brand)', fontSize:'.8rem', fontFamily:'var(--font-body)' }}>
            Super Admin: superadmin@example.com
          </button>
        </div>
      </div>
    </div>
  );
}
